/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	})();
	
	(function () {
	  (0, _module.mainSlider)();
	})();
	
	(function () {
	  (0, _module.headerResize)();
	})();
	
	(function () {
	  (0, _module.togglePagetop)();
	})();
	
	(function () {
	  (0, _module.toggleMenu)();
	})();
	
	(function () {
	  (0, _module.toggleAccordion)();
	})();
	
	(function () {
	  (0, _module.beforeValidate)();
	})();
	
	$(window).on("load", function () {
	  $("body").addClass("loaded");
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.togglePlay = exports.beforeValidate = exports.toggleAccordionYotalog = exports.toggleAccordionNews = exports.toggleAccordionWorks = exports.toggleAccordion = exports.toggleMenu = exports.togglePagetop = exports.headerResize = exports.mainSlider = exports.anchorLink = void 0;
	var breakPoint = 750;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// mainSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var mainSlider = function mainSlider() {
	  $('.slider').slick({
	    autoplay: true,
	    autoplauSpeed: 5000,
	    infinite: true,
	    speed: 1000,
	    slidesToShow: 3,
	    centerMode: false,
	    variableWidth: true,
	    focusOnSelect: true,
	    arrows: false,
	    dots: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// headerResize
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.mainSlider = mainSlider;
	
	var headerResize = function headerResize() {
	  $(window).on("scroll load", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > 200) {
	      $(".st-Header").addClass("scrolled");
	      $(".st-Header_Inner").addClass("scrolled");
	    } else {
	      $(".st-Header").removeClass("scrolled");
	      $(".st-Header_Inner").removeClass("scrolled");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// togglePagetop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.headerResize = headerResize;
	
	var togglePagetop = function togglePagetop() {
	  $(window).on("load scroll", function () {
	    var docHeight = $('body').height();
	    var footerHeight = 87;
	    var scrollHeight = $(this).scrollTop();
	    windowHeight = window.innerHeight;
	
	    if (scrollHeight > 300) {
	      $(".st-Pagetop").addClass("visible");
	    } else {
	      $(".st-Pagetop").removeClass("visible");
	    }
	
	    if (windowWidth > 750) {
	      if (footerHeight > docHeight - scrollHeight - windowHeight) {
	        $(".st-Pagetop").css({
	          "bottom": "107px",
	          "position": "absolute"
	        });
	      } else {
	        $(".st-Pagetop").css({
	          "bottom": "20px",
	          "position": "fixed"
	        });
	      }
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.togglePagetop = togglePagetop;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header_Hamburger > button').on('click', function () {
	    $(this).toggleClass("close");
	    $(".st-Header_Hamburger").toggleClass("open");
	    $(".st-Header_Slide").toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// toggleAccordion
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var toggleAccordion = function toggleAccordion() {
	  $(".rec-List li a").on("click", function () {
	    $(this).prev().toggleClass("open");
	    $(this).next().slideToggle(400);
	  });
	  $(".rec-List li button").on("click", function () {
	    $(this).toggleClass("open");
	    $(this).next().next().slideToggle(400);
	  });
	  $(window).on("load", function () {
	    var hash = location.hash;
	
	    if (hash) {
	      var target = $(hash).parent();
	      $(target).children("button").toggleClass("open");
	      $(target).children(".accordion").slideToggle(400);
	      $("html,body").animate({
	        scrollTop: $(hash).offset().top
	      });
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleAccordionWorks
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleAccordion = toggleAccordion;
	
	var toggleAccordionWorks = function toggleAccordionWorks() {
	  $(".story a, .chronology a").on("click", function () {
	    $(this).parent().toggleClass("open");
	    $(this).prev().toggleClass("open");
	    $(this).next().slideToggle(400);
	  });
	  $(".story button, .chronology button").on("click", function () {
	    $(this).parent().toggleClass("open");
	    $(this).toggleClass("open");
	    $(this).next().next().slideToggle(400);
	  });
	}; // ------------------------------------------------------------------------
	// toggleAccordionNews
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleAccordionWorks = toggleAccordionWorks;
	
	var toggleAccordionNews = function toggleAccordionNews() {
	  if (windowWidth <= breakPoint) {
	    $(".nws-Sidebar").on("click", function () {
	      $(this).children(".accordion").slideToggle(400);
	      $(this).toggleClass("open");
	    });
	  }
	}; // ------------------------------------------------------------------------
	// toggleAccordionYotalog
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleAccordionNews = toggleAccordionNews;
	
	var toggleAccordionYotalog = function toggleAccordionYotalog() {
	  if (windowWidth <= breakPoint) {
	    $(".yot-Archive").on("click", function () {
	      $(this).children(".accordion").slideToggle(400);
	      $(this).toggleClass("open");
	      $(this).children(".title").children("h3").toggleClass("open");
	      $(this).children(".title").children("p").toggleClass("open");
	    });
	    $(".yot-Sidebar").on("click", function () {
	      $(this).children(".accordion").slideToggle(400);
	      $(this).toggleClass("open");
	    });
	  }
	}; // ------------------------------------------------------------------------
	// togglePlay
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleAccordionYotalog = toggleAccordionYotalog;
	
	var togglePlay = function togglePlay() {
	  var flag = 1;
	  $(".movie-toggle video").on("click", function () {
	    if (flag == 0) {
	      console.log(flag);
	      this.pause();
	      flag = 1;
	    } else {
	      this.play();
	      flag = 0;
	      console.log(flag);
	    }
	
	    $(this).parent().toggleClass("play");
	  });
	}; // ------------------------------------------------------------------------
	// beforeValidate
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.togglePlay = togglePlay;
	
	var beforeValidate = function beforeValidate() {
	  $(".before-form button").on("click", function () {
	    if ($(".before-form #check").prop('checked') == true) {
	      location.href = location.href + "form/";
	      console.log(location.href + "form/");
	      return false;
	    } else {
	      $('.before-form .error').css('display', 'block');
	      return false;
	    }
	  });
	};
	
	exports.beforeValidate = beforeValidate;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// contact/app.bundle.js